/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * DSV Public API
 * DSV Public API
 * OpenAPI spec version: 1.2.3
 */

export type EventRegistrationType = typeof EventRegistrationType[keyof typeof EventRegistrationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventRegistrationType = {
  PARTICIPANT: 'PARTICIPANT',
  LEADER: 'LEADER',
  MYSELF: 'MYSELF',
  FAMILY: 'FAMILY',
  FAMILY_MEMBERS: 'FAMILY_MEMBERS',
  ME_AND_OTHERS: 'ME_AND_OTHERS',
  ADMIN: 'ADMIN',
} as const;
